import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Checkbox } from '../../../components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { UserPlus } from 'lucide-react';

export const PersonalInfoSection = ({ formData, handleChange }) => (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold font-[Manrope] flex items-center gap-2">
          <UserPlus className="w-5 h-5 text-red-500" />
          Personal Information
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <Label htmlFor="full_name">Full Name *</Label>
          <Input
            id="full_name"
            value={formData.full_name}
            onChange={(e) => handleChange('full_name', e.target.value)}
            placeholder="Enter patient's full name"
            data-testid="input-full-name"
          />
        </div>

        <div>
          <Label htmlFor="date_of_birth">Date of Birth <span className="text-red-500">*</span></Label>
          <Input
            id="date_of_birth"
            type="date"
            value={formData.date_of_birth}
            onChange={(e) => handleChange('date_of_birth', e.target.value)}
            data-testid="input-dob"
            required
          />
        </div>

        <div>
          <Label htmlFor="gender">Gender <span className="text-red-500">*</span></Label>
          <Select value={formData.gender} onValueChange={(v) => handleChange('gender', v)} required>
            <SelectTrigger data-testid="select-gender">
              <SelectValue placeholder="Select gender" />
            </SelectTrigger>
            <SelectContent position="popper" sideOffset={5}>
              <SelectItem value="male">Male</SelectItem>
              <SelectItem value="female">Female</SelectItem>
              <SelectItem value="other">Other</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label htmlFor="phone">Phone Number</Label>
          <Input
            id="phone"
            type="tel"
            value={formData.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            placeholder="+91 XXXXXXXXXX"
            data-testid="input-phone"
          />
        </div>

        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="patient@example.com"
            data-testid="input-email"
          />
        </div>

        <div className="md:col-span-2">
          <Label htmlFor="address">Address <span className="text-red-500">*</span></Label>
          <Textarea
            id="address"
            value={formData.address}
            onChange={(e) => handleChange('address', e.target.value)}
            placeholder="Enter complete address"
            data-testid="input-address"
            required
          />
        </div>

        <div>
          <Label htmlFor="occupation">Occupation</Label>
          <Input
            id="occupation"
            value={formData.occupation}
            onChange={(e) => handleChange('occupation', e.target.value)}
            placeholder="Patient's occupation"
          />
        </div>

        <div className="flex items-center gap-3 pt-6">
          <Checkbox
            id="medico_legal"
            checked={formData.is_medico_legal_case}
            onCheckedChange={(checked) => handleChange('is_medico_legal_case', checked)}
          />
          <div>
            <Label htmlFor="medico_legal" className="cursor-pointer font-medium">
              Medico-Legal Case
            </Label>
            <p className="text-xs text-slate-500 mt-0.5">
              Records retained for 10 years (instead of standard 3 years)
            </p>
          </div>
        </div>
      </CardContent>
    </Card>

);
